import { render, staticRenderFns } from "./Pendencias.vue?vue&type=template&id=ea61a716&"
import script from "./Pendencias.vue?vue&type=script&lang=js&"
export * from "./Pendencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports